// Un texto escrito por una persona, con sus enlaces vivos.
//
// Lissette, 2026-09-04, queja 66: un anuncio con una direccion dentro salia
// como texto muerto y habia que copiarla a mano.
//
// Pinta TROZOS (ver crm-app/enlacesEnTexto.js), nunca HTML volcado: el cuerpo
// de un anuncio lo escribe una persona, y armar HTML con eso es justo lo que
// la CSP de la aplicacion existe para impedir.
//
// `rel="noopener noreferrer"` y `target="_blank"`: el sitio de destino no puede
// tocar la pestana de Deskte, y el enlace no se lleva a nadie de su pantalla.
import { trozosConEnlaces } from '../enlacesEnTexto.js';

export function TextoConEnlaces({ texto, color = 'var(--c-cyan,#00d4ff)' }) {
  const trozos = trozosConEnlaces(texto);
  return (
    <>
      {trozos.map((t, i) => (t.tipo === 'enlace'
        ? (
          <a
            key={i}
            href={t.href}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
            style={{ color, textDecoration: 'underline', wordBreak: 'break-all' }}
          >
            {t.valor}
          </a>
        )
        : t.valor))}
    </>
  );
}
